<xm-medication-widget-view
  [items]="medicationItems()"
  [title]="title"
  [searchFn]="searchMedication$"
  [canAdd]="canAdd()"
  [canDelete]="canDelete()"
  [isProcessing]="isProcessing()"
  [usePrimaryText]="settings?.themeWidgetText"
  (itemAdded)="onItemAdded($event)"
  (itemRemoved)="onItemRemoved($event)"
  (addNewItem)="onAddNewItem($event)"
  (libraryProductSelected)="onLibraryProductSelected($event)">

  @if (canSaveScript() && allowScriptPrinting() && hasMedication) {
    <button
      widget-footer
      mat-flat-button
      color="primary"
      class="w-100"
      xuiConfirmationDialog
      [confirmMessage]="confirmationMessage"
      (confirm)="saveScript()">
      Save Script
    </button>
  }
</xm-medication-widget-view>
